<template>
  <div>
    <line-chart :chart-data="{ labels: chartLabels, datasets: chartData }" :options="chartOptions" class="small"></line-chart>
    <!-- <button @click="fillData()">Randomize</button> -->
  </div>
</template>

<script>
  import LineChart from './LineChart.js'

  export default {
    components: {
      LineChart
    },
    props: {
        chartData: Array,
        chartLabels: Array,
    },
    data () {
      return {
        datacollection: {
        //     labels: [1, 2, 3, 4, 5],
        //   datasets: [
        //     {
        //       label: 'Lukalus',
        //       borderColor: '#EF3E36',
        //       backgroundColor: null,
        //         fill: false,
        //         lineTension: 0.1,

        //       data: [1, 2, 3 ,4, 5]
        //     }, 
        //   ]
        },
        chartOptions: {
            chart: {
                },
            hover: true,
            responsive: true,
            maintainAspectRatio: false,
        }
      }
    },
    async mounted () {
      await this.fillData()
    //   this.$forceUpdate()
    },
    methods: {
      async fillData () {
        this.datacollection = {
          labels: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
          datasets: [
            {
              label: 'Lukalus',
              borderColor: '#EF3E36',
              backgroundColor: null,
                fill: false,
                lineTension: 0.1,

              data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            }, 
            {
              label: 'Jana',
              borderColor: '#17BEBB',
              backgroundColor: null,
            fill: false,
            lineTension: 0.1,

              data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            },
            {
              label: 'Vorel',
              borderColor: '#540D6E',
              backgroundColor: null,
            fill: false,
            lineTension: 0.1,

              data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            },
            {
              label: 'Test',
              borderColor: '#FFD23F',
              backgroundColor: null,
            fill: false,
            lineTension: 0.1,
              data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            }
          ]
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    }
  }
</script>

<style>
  .small {
    /* width: 100%;
    height: 200px; */
    /* height: 300px; */
    height: 100%;
    width: 100%;
    /* margin:  150px auto; */
    /* border: 1px solid black; */
    /* background-color: white; */
  }
</style>


// WEBPACK FOOTER //
// src/components/charts/RandomChart.vue